import React from "react";
import SEO from "../components/SEO";
import LegalShell from "../components/LegalShell";

export default function ProtectionDonnees() {
  return (
    <LegalShell eyebrow="Légal · RGPD" title="Charte de protection des données" lastUpdate="29 avril 2026" testid="page-donnees">
      <SEO
        title="Charte de protection des données · MetaConnect"
        description="Politique de protection des données personnelles MetaConnect, conforme au RGPD et à la loi Informatique et Libertés."
        canonical="/donnees"
      />

      <p className="legal-note">
        MetaConnect attache une importance particulière à la protection de vos données
        personnelles. La présente charte est conforme au Règlement (UE) 2016/679 du Parlement
        européen (RGPD) et à la loi n° 78-17 du 6 janvier 1978 modifiée, dite «&nbsp;Informatique
        et Libertés&nbsp;».
      </p>

      <h2>1. Responsable du traitement</h2>
      <p>
        Le responsable du traitement des données collectées via le site metaconnect.fr est&nbsp;:
      </p>
      <ul>
        <li><strong>Raison sociale</strong> : METACONNECT.FR (SAS)</li>
        <li><strong>Siège social</strong> : 68 route de la Ferté-Saint-Aubin, 45150 Jargeau, France</li>
        <li><strong>SIREN</strong> : 931 999 833 — <strong>RCS</strong> : Orléans</li>
        <li><strong>Représentant légal</strong> : Monsieur Benoît Tommasino, Président</li>
        <li><strong>Email de contact RGPD</strong> : <a href="mailto:contact@metaconnect.fr">contact@metaconnect.fr</a></li>
        <li><strong>Téléphone</strong> : 01 89 70 97 49</li>
        <li>
          <strong>Délégué à la protection des données (DPO)</strong>&nbsp;: aucun DPO n'est
          désigné, la désignation n'étant pas obligatoire au sens de l'article 37 du RGPD pour
          l'activité actuelle. Toutes les demandes RGPD peuvent être adressées au responsable du
          traitement à l'adresse ci-dessus.
        </li>
      </ul>

      <h2>2. Données collectées et finalités</h2>
      <p>Nous collectons uniquement les données strictement nécessaires aux finalités suivantes&nbsp;:</p>
      <table className="legal-table">
        <thead>
          <tr><th>Finalité</th><th>Données collectées</th><th>Base légale</th><th>Conservation</th></tr>
        </thead>
        <tbody>
          <tr>
            <td>Demande de démonstration</td>
            <td>Nom, prénom, email professionnel, organisation, fonction, message</td>
            <td>Mesures précontractuelles (art. 6.1.b RGPD)</td>
            <td>3 ans à compter du dernier contact</td>
          </tr>
          <tr>
            <td>Demande de contact</td>
            <td>Nom, email, sujet, message</td>
            <td>Intérêt légitime (art. 6.1.f RGPD)</td>
            <td>3 ans à compter du dernier contact</td>
          </tr>
          <tr>
            <td>Administration du blog</td>
            <td>Email administrateur, mot de passe (haché)</td>
            <td>Exécution du contrat (art. 6.1.b RGPD)</td>
            <td>Durée de la relation contractuelle + 5 ans</td>
          </tr>
          <tr>
            <td>Mesures de sécurité</td>
            <td>Logs techniques, adresse IP</td>
            <td>Intérêt légitime (art. 6.1.f RGPD)</td>
            <td>12 mois maximum</td>
          </tr>
          <tr>
            <td>Support à distance (prise en main)</td>
            <td>Nom, email, téléphone, organisation, motif, adresse IP, horodatage, user-agent du navigateur</td>
            <td>Consentement explicite (art. 6.1.a RGPD) — case à cocher obligatoire</td>
            <td>12 mois maximum après clôture de la session</td>
          </tr>
        </tbody>
      </table>

      <h2>3. Destinataires des données</h2>
      <p>
        Vos données sont destinées exclusivement aux services internes habilités de MetaConnect.
        Aucune donnée n'est cédée, vendue ou louée à des tiers à des fins commerciales.
      </p>
      <p>
        Certaines données peuvent être traitées par des sous-traitants techniques agissant pour
        le compte de MetaConnect (hébergement, envoi d'emails transactionnels). Ces sous-traitants
        sont liés par un contrat conforme à l'article 28 du RGPD&nbsp;:
      </p>
      <ul>
        <li><strong>Hébergement applicatif &amp; CDN</strong> : Emergent (emergent.sh) — opéré par Emergent Agi Inc., avec un CDN Cloudflare.</li>
        <li><strong>Hébergement du nom de domaine</strong> : OVH SAS — 2 rue Kellermann, 59100 Roubaix, France — RCS Lille Métropole 424 761 419.</li>
        <li><strong>Envoi d'emails transactionnels</strong> : Resend, Inc. (Delaware, États-Unis) — Clauses contractuelles types (CCT) de la Commission européenne.</li>
        <li><strong>Prise de rendez-vous</strong> : Calendly LLC (États-Unis) — CCT applicables.</li>
      </ul>

      <h2>4. Transferts hors Union européenne</h2>
      <p>
        Lorsqu'un transfert de données vers un pays tiers est nécessaire (par exemple Resend ou
        Calendly hébergés aux États-Unis), il est encadré par les Clauses Contractuelles Types
        adoptées par la Commission européenne (Décision 2021/914), garantissant un niveau de
        protection adéquat conforme au RGPD.
      </p>

      <h2>5. Sécurité des données</h2>
      <p>
        MetaConnect met en œuvre les mesures techniques et organisationnelles appropriées pour
        garantir un niveau de sécurité adapté au risque, notamment&nbsp;:
      </p>
      <ul>
        <li>chiffrement des communications (HTTPS/TLS 1.3)&nbsp;;</li>
        <li>hachage des mots de passe (bcrypt)&nbsp;;</li>
        <li>authentification forte des accès administrateurs (JWT, sessions limitées)&nbsp;;</li>
        <li>journalisation des accès et opérations sensibles&nbsp;;</li>
        <li>politique de mots de passe robustes et rotation régulière&nbsp;;</li>
        <li>hébergement chez des prestataires conformes RGPD et, pour les données de santé, certifiés HDS.</li>
      </ul>

      <h2>6. Vos droits</h2>
      <p>
        Conformément aux articles 15 à 22 du RGPD, vous disposez des droits suivants sur vos
        données personnelles&nbsp;:
      </p>
      <ul>
        <li><strong>Droit d'accès</strong> : obtenir la confirmation que des données vous concernant sont traitées et en obtenir une copie&nbsp;;</li>
        <li><strong>Droit de rectification</strong> : faire corriger des données inexactes ou incomplètes&nbsp;;</li>
        <li><strong>Droit à l'effacement</strong> («&nbsp;droit à l'oubli&nbsp;»)&nbsp;: demander la suppression de vos données dans les conditions prévues par le RGPD&nbsp;;</li>
        <li><strong>Droit à la limitation</strong> : demander la suspension temporaire d'un traitement&nbsp;;</li>
        <li><strong>Droit à la portabilité</strong> : récupérer vos données dans un format structuré, couramment utilisé et lisible par machine&nbsp;;</li>
        <li><strong>Droit d'opposition</strong> : vous opposer au traitement pour motif légitime, notamment en matière de prospection&nbsp;;</li>
        <li><strong>Droit de définir des directives</strong> relatives au sort de vos données après votre décès.</li>
      </ul>
      <p>
        Pour exercer ces droits, écrivez-nous à&nbsp;
        <a href="mailto:contact@metaconnect.fr">contact@metaconnect.fr</a> en justifiant de votre
        identité. Une réponse vous sera apportée dans un délai d'un (1) mois, prorogeable de deux
        (2) mois en cas de demande complexe.
      </p>
      <p>
        Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés, vous
        pouvez adresser une réclamation à la Commission Nationale de l'Informatique et des
        Libertés (CNIL)&nbsp;: <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">www.cnil.fr</a>.
      </p>

      <h2>7. Cookies et traceurs</h2>
      <p>
        Le site metaconnect.fr utilise un nombre limité de cookies&nbsp;:
      </p>
      <ul>
        <li><strong>Cookies strictement nécessaires</strong> : authentification de l'espace administrateur et de l'espace pro (jetons JWT en stockage local). Ces cookies ne nécessitent pas de consentement (art. 82 LIL).</li>
        <li><strong>Cookies de mesure d'audience (Google Analytics 4)</strong> : déposés <em>uniquement</em> après votre acceptation explicite via la bannière. Mode anonymisé (anonymize_ip), sans signal Google ni publicité personnalisée. Conservation : 14&nbsp;mois.</li>
        <li><strong>Cookies tiers (Calendly)</strong> : déposés uniquement lors de l'utilisation effective du calendrier de prise de rendez-vous, après votre interaction explicite.</li>
      </ul>
      <p>
        Vous pouvez à tout moment modifier votre choix via le lien
        «&nbsp;Gérer mes cookies&nbsp;» en pied de page. Aucun cookie publicitaire n'est utilisé.
      </p>

      <h2>8. Conservation des données</h2>
      <p>
        Les durées de conservation sont précisées au tableau de l'article 2. À l'issue de ces
        durées, les données sont soit supprimées, soit anonymisées à des fins statistiques.
      </p>

      <h2>9. Données de santé</h2>
      <p>
        Le site vitrine metaconnect.fr ne collecte ni ne traite de données de santé. Les données
        de santé éventuellement traitées dans le cadre des services applicatifs MetaConnect
        souscrits par un client professionnel sont régies par un contrat distinct et hébergées
        en France auprès d'un hébergeur certifié HDS conformément à l'article L.1111-8 du Code de
        la santé publique.
      </p>

      <h2>10. Modification de la charte</h2>
      <p>
        MetaConnect se réserve le droit de modifier la présente charte à tout moment, notamment
        pour se conformer à toute évolution législative, réglementaire ou technique. La version
        en vigueur est celle accessible sur le site à la date de votre consultation.
      </p>

      <h2>11. Contact</h2>
      <p>
        Pour toute question relative à la protection de vos données personnelles, vous pouvez
        nous écrire à&nbsp;: <a href="mailto:contact@metaconnect.fr">contact@metaconnect.fr</a>.
      </p>
    </LegalShell>
  );
}
